// Устройство пушей текущей сессии: id строки device_infos, которую AppHeader создал при
// регистрации FCM-токена.
//
// Повод (prod 2026-10-16): FCM-токен — это установка приложения, а не пользователь. При
// выходе строка оставалась за аккаунтом, и после входа под другим его пуши продолжали
// приходить на телефон в обход настроек вошедшего. Сервер теперь сам переносит токен
// на вошедшего (api DeviceInfosController#create), а выход удаляет строку — чтобы на
// телефоне без сессии не всплывали чужие брони и сообщения.
//
// Модульная переменная, а не стор: выход реализован в трёх компонентах (App, AppHeader,
// Drawer), а id нужен всем трём; персистить его незачем — AppHeader регистрирует токен
// заново на каждом монтировании после входа.

import { markIntentionalLogout } from "@/utils/sessionExpiry";

let deviceInfoId = null;

// Ответ POST /api/v1/device_infos: созданная строка ({ id, ... }) или
// { error: "Token already exists", id } — токен уже за этим пользователем.
export function rememberPushDevice(response) {
  const id = response && response.data && response.data.id;
  if (id) deviceInfoId = id;
}

// Регистрирует FCM-токен за вошедшим (сервер забирает его у прежнего владельца) и запоминает
// id строки для выхода. Ошибку отдаёт вызывающему — показывать её решает он.
export function registerPushDevice(vm, token, deviceType) {
  return vm.axios
    .post(
      "/api/v1/device_infos",
      { device_infos: { device_type: deviceType, token: token } },
      { headers: { Authorization: vm.$store.getters.getAuthToken } }
    )
    .then(rememberPushDevice);
}

// Удаляет устройство до отзыва JWT (после sign_out запрос уже не авторизовать).
// Запрос — часть намеренного выхода: 401 на протухшем токене не должен показать
// «сессия истекла» и разлогинить раньше sign_out (FT-136, sessionExpiry.js).
// Никогда не отклоняется и не держит выход дольше таймаута: сбой здесь не должен мешать
// выйти, а оставшуюся строку перехватит следующий вход на этом телефоне.
export function forgetPushDevice(vm) {
  const id = deviceInfoId;
  deviceInfoId = null;
  if (!id) return Promise.resolve();

  return vm
    .axios(
      markIntentionalLogout({
        url: `/api/v1/device_infos/${id}`,
        method: "delete",
        timeout: 3000,
        headers: { Authorization: vm.$store.getters.getAuthToken },
      })
    )
    .catch(() => {});
}
